import { BulkRequest, Id, SelectedRows } from "@dgs/core";
import { BulkRequestWithFilterId } from "../types/bulkRequestWithFilterId";

export const mapToBulkRequest = (selectedRows: SelectedRows, search?: string | null): BulkRequest => ({
	ids: selectedRows === "all" ? null : selectedRows,
	all: selectedRows === "all",
	search,
});

export const mapToBulkRequestWithFilterId = (
	selectedRows: SelectedRows,
	filterId: Id | null,
	search?: string | null,
): BulkRequestWithFilterId => ({
	...mapToBulkRequest(selectedRows, search),
	filterId,
});
